// extracted by mini-css-extract-plugin
export var dot = "colored-select-option-module--dot--c53eb";
export var option = "colored-select-option-module--option--3af0f";